import { render, staticRenderFns } from "./RenderClassTestPerfomRate.vue?vue&type=template&id=2aac3f5c&scoped=true"
import script from "./RenderClassTestPerfomRate.vue?vue&type=script&lang=js"
export * from "./RenderClassTestPerfomRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac3f5c",
  null
  
)

export default component.exports